<template>
  <div class="lsit">
    <div class="set" style="background-color: #e2ebf1">
      <listTree :treedata="treeData" @trreList="trreListCurve" @serchBten="serchBten" />
    </div>
    <!-- 左边 -->
    <div class="left">
      <div class="timeout">
        <div class="times">
          <el-date-picker
            v-model="value1"
            type="datetimerange"
            :range-separator="$t('reach')"
            format="yyyy/MM/dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>

          <div style="width: 50px; height: 0" class="bten">
            <el-button
              type="primary"
              @click="comgAdd"
              style="padding: 6px 20px !important"
              >确定</el-button
            >
          </div>
        </div>

        <!--  -->
        <div class="dayTime">
          <el-radio-group v-model="tabPosition" @change="houTimes">
            <el-radio-button label="1hour">1小时</el-radio-button>
            <el-radio-button label="2hour">2小时</el-radio-button>
            <el-radio-button label="1day">1天</el-radio-button>
            <el-radio-button label="1week">1周</el-radio-button>
            <el-radio-button label="1month">1月</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="lefRight">
        <div class="left_warp">
          <div class="dataTable">
            历史数据
            <div class="filet">
              文件类型:
              <el-select v-model="Filevalue" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.lable"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <i
                class="el-icon-download"
                style="font-size: 22px; margin-left: 10px; cursor: pointer"
                @click="myFileupData"
              ></i>
            </div>
            <div class="icon">
              <img
                src="@/assets/img/ck.png"
                @click="lishData('历史数据')"
                alt="窗口化"
                title="窗口化"
              />
            </div>
          </div>
          <div style="padding: 10px 0">
            <!-- <table class="table" style="width:550px;border:1px solid  #EBEEF5;text-align: center;" >
              <thead>
                <tr>
                  <th style="text-align: center;">日期</th>
                  <th v-for="item in dataDome" :key="item.channelid"  style="text-align: center;">
                    <td   style="width:70px; display:block;">{{ lang_file == 'zh-cn'? item.unittype : item.unittype_en}}</td>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr  v-for="(item,index) in contentList"
                    :key="index" >
                      <td  :class=" index % 2 == 0  ? 'warning' :'errof'" style="width:130px"  v-if="dataDome != ''">{{contentList[0].addtime}}</td>
                  <td
                    v-for="(tables,indexLit) in Lxpush"
                    :key="indexLit"
                    :class=" index % 2 == 0  ? 'warning' :'errof'"
                  >{{item[tables]}}</td>
                 
                </tr> 
              </tbody>
            </table> -->
            <el-table
              :data="contentList"
              border
              style="width: 100%"
              :row-class-name="tableRowClassName"
              max-height="450"
            >
              <el-table-column
                prop="collecttime"
                label="日期"
                fixed
                width="130"
                v-if="Lxpush != ''"
              ></el-table-column>
              <el-table-column
                v-for="(item, index) in dataDome"
                :prop="Lxpush[index]"
                :label="item.unittype"
                :key="item.channelid"
              ></el-table-column>
            </el-table>
            <div style="overflow: auto">
              <dataPheader
                :page-data="pageData"
                :total="total"
                :get-table-list="lin_Data"
              ></dataPheader>
            </div>
          </div>
        </div>
        <div class="right_warp">
          <div class="dataTable">
            实时数据
            <div class="icon">
              <img
                src="@/assets/img/ck.png"
                @click="lishData('实时数据')"
                alt="窗口化"
                title="窗口化"
              />
            </div>
          </div>
          <!-- 折线图 -->
          <div id="myChart" :style="{ width: '100%', height: '370px' }"></div>

          <div class="zhe_boots">
            <el-radio-group v-model="channelidType" @change="channerData">
              <el-radio-button
                :label="'channel' + item.channelid"
                v-for="item in titleArr"
                :key="item.channelid"
                >{{
                  lang_file == "zh-cn" ? item.unittype : item.unittype_en
                }}</el-radio-button
              >
            </el-radio-group>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="fly"
      :visible.sync="dialogVisibleDataOf"
      :modal="false"
      :fullscreen="true"
      width="95%"
    >
      <!-- 历史数据 -->
      <liData
        :cheid-fengxiang="dataDome"
        :channelid-list="contentList"
        v-if="fly == '历史数据'"
        :conetn-cunt="Lxpush"
        :page-data="pageData"
        :total="total"
        :lin-data="lin_Data"
      />
      <!-- 数据曲线 -->
      <data_line
        v-if="fly == '实时数据'"
        :data-x="dataX"
        :collecttime="collecttime"
        :channelid="titleArr"
        :title-obj="titleObj"
        :teab="channelidType"
        ref="datalineList"
        @channelidfuntEnd="channelidfuntEnd"
      />
    </el-dialog>
  </div>
</template>

<script>
import listTree from "@/components/common/listTree";
import { times } from "@/components/common/time";
import { treeinfo, getdata, getdataexportData } from "../../network/index";
import timeConvert from "../../components/common/newTimes";
import liData from "./components/liData";
import data_line from "./components/data_line";
import dataPheader from "@/components/common/dataPheader";
export default {
  components: {
    listTree,
    liData,
    data_line,
    dataPheader,
  },
  data() {
    return {
      options: [
        {
          lable: "导出Excel",
          id: "0",
        },
      ],
      Filevalue: "0",
      dialogVisibleDataOf: false,
      fly: "",
      treeData: [],
      lang_file: sessionStorage.getItem("lang_file"),
      channelidType: "",
      value1: "",
      tabPosition: "1day",
      gateway_uuid: "E2DC0F5194756B740D72EF44DE54B8F4",
      pageData: {
        zpagenum: 1, //页码  pagenum  2
        zpagesize: 30, //数据   pagesize几条数据
      },
      dateset: "1day", //
      begindate: "", //开始时间
      enddate: "", //结束时间
      titleArr: [],
      channel: "",
      dataDome: [],
      contentList: [],
      Lxpush: [],
      dataX: [],
      collecttime: [],
      objUnit: {},
      titleObj: {},
      excle: "",
      total: null,
      channelTypeInfo: "",
    };
  },
  created() {},
  mounted() {
    this.treeinfo();
    // this.dataOline()
    // this.lin_Data()
    this.drawLine();
    this.monthList();
  },
  methods: {
    serchBten(e) {
      this.flyTay = true;
      this.treeinfo(e);
    },
    // 斑马线
    tableRowClassName({ row, rowIndex }) {
      let index = rowIndex + 1;
      if (index % 2 == 0) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
    /**
     * 导出export
     */
    async myFileupData() {
      let { begindate, enddate, dateset, gateway_uuid } = this;
      // const {code,data,msg} = await getdataexportData(begindate,enddate,dateset,gateway_uuid)
      let appid = sessionStorage.getItem("token");

      const lang_file = sessionStorage.getItem("lang_file");
      if (this.excle != "") {
        location.href = `http://39.103.154.86/api/Gatewaydata/getdata_export?begindate=${begindate}&enddate=${enddate}&dateset=${dateset}&gateway_uuid=${gateway_uuid}&appid=${appid}&lang_file=${lang_file}`;
      } else {
        this.$message.error("数据不能为空");
      }

      // if(code){
      //    console.log('11');

      // }else{
      //   this.$message.error(msg)
      // }
    },
    /**
     * 子组件传过来的值
     */
    channelidfuntEnd(e) {
      // console.log(e);
      this.channelidType = e;
      this.channel = e;
      // this.taeb = e
      this.lin_Data();
      this.channerData(e);

      // this.$refs.dataLine.channelidType = e;
    },
    /***确定 */
    comgAdd() {
      this.begindate = this.value1[0];
      this.enddate = this.value1[1];
      this.lin_Data();
    },
    /*
    获取一个月的时间
     */
    monthList() {
      let timeArr = [];
      let num = 1;
      var frontOneHour = new Date(new Date().getTime());
      let hwd = new Date(new Date().getTime() - 24 * 60 * 60 * 1000);
      let timesD = timeConvert(hwd, num); //前2个小时
      let timesEndD = timeConvert(frontOneHour, num); //当前时间
      timeArr.push(timesD, timesEndD);
      this.value1 = timeArr;
    },
    /**天 小时  月  */
    houTimes(e) {
      this.dateset = e;
      let num = 1;
      let timeArr = [];
      var frontOneHour = new Date(new Date().getTime());
      /**获取 1小时 2销售  1天 1周  1个月 */
      switch (e) {
        case "1hour":
          let w = new Date(new Date().getTime() - 1 * 60 * 60 * 1000);
          let times = timeConvert(w, num); //前一个小时
          let timesEnd = timeConvert(frontOneHour, num); //当前时间
          timeArr.push(times, timesEnd);
          this.value1 = timeArr;
          break;
        case "2hour":
          let hw = new Date(new Date().getTime() - 2 * 60 * 60 * 1000);
          let timesH = timeConvert(hw, num); //前2个小时
          let timesEndH = timeConvert(frontOneHour, num); //当前时间
          timeArr.push(timesH, timesEndH);
          this.value1 = timeArr;
          break;
        case "1day": //天
          let hwd = new Date(new Date().getTime() - 24 * 60 * 60 * 1000);
          let timesD = timeConvert(hwd, num); //前2个小时
          let timesEndD = timeConvert(frontOneHour, num); //当前时间
          timeArr.push(timesD, timesEndD);
          this.value1 = timeArr;
          break;
        case "1week": //周
          let hwdK = new Date(new Date().getTime() - 168 * 60 * 60 * 1000);
          let timesDK = timeConvert(hwdK, num); //前2个小时
          let timesEndDK = timeConvert(frontOneHour, num); //当前时间
          timeArr.push(timesDK, timesEndDK);
          this.value1 = timeArr;
          break;
        case "1month": //月
          let hwdKH = new Date(new Date().getTime() - 720 * 60 * 60 * 1000);
          let timesDKH = timeConvert(hwdKH, num); //前2个小时
          let timesEndDKH = timeConvert(frontOneHour, num); //当前时间
          timeArr.push(timesDKH, timesEndDKH);
          this.value1 = timeArr;
          break;
      }
      this.dataOline();
    },
    /**折线图下方按钮*/
    channerData(e) {
      this.channel = e;
      this.channelidType = e;
      let splNew = e.split("l")[1];
      /**获取标题  */
      this.titleArr.forEach((item) => {
        // console.log(item.unittype_en);

        if (item.channelid == splNew) {
          this.objUnit = {
            unit: item.unit,
            unittype: this.lang_file == "zh-cn" ? item.unittype : item.unittype_en,
          };
        }
      });

      this.lin_Data();
    },
    lishData(e) {
      this.fly = e;

      this.dialogVisibleDataOf = true;
    },
    // 实时数据
    trreListCurve(e) {
      this.gateway_uuid = e;
      this.dataOline();
      // this.lin_Data()
    },
    // 页面初始化的数据
    async dataOline() {
      let pagesize = 1;
      let pagenum = 1;
      let dataList = {
        gateway_uuid: this.gateway_uuid,
        pagenum,
        pagesize,
      };
      const { code, data, msg } = await getdata(dataList);
      let { channelinfo } = data;
      if (channelinfo != "") {
        let arrNot = [];
        channelinfo.forEach((item) => {
          if (item.unittype != "风向" && "最大降雨量" && "最小降雨量") {
            // console.log(item);
            arrNot.push(item);
          }
        });
        this.channel = "channel" + arrNot[0].channelid;
        this.channelTypeInfo = arrNot[0].channelid;
        // console.log( this.channelTypeInfo );

        this.channelidType = "channel" + arrNot[0].channelid;
        this.lin_Data();
      }
    },
    // 折线图
    async lin_Data() {
      let pagesize = this.pageData.zpagesize;
      let pagenum = this.pageData.zpagenum;
      let gateway_uuid = this.gateway_uuid;
      let datainfo = {
        gateway_uuid,
        pagenum,
        pagesize,
        dateset: this.dateset,
        begindate: this.begindate,
        enddate: this.enddate,
        channelid: this.channelTypeInfo,
      };
      const { code, data, msg } = await getdata(datainfo);
      // console.log(data);
      this.excle = data;
      if (code) {
        // 获取y周的数据
        let Yechart = [];
        let Xechart = [];
        if (data.list != undefined && data.list.length > 0) {
          this.total = Number(data.pagelist[0].allrow);
          data.list.forEach((item) => {
            Yechart.push(item[this.channelidType]);

            Xechart.push(item.collecttime);
          });
          this.dataX = Yechart;
          this.collecttime = Xechart;
        }

        /**折线图下方按钮 */
        let channelinfolist = [];
        if (data.list != undefined && data.list.length > 0) {
          data.channelinfo.forEach((item) => {
            if (item.unittype != "风向" && "最大降雨量" && "最小降雨量") {
              channelinfolist.push(item);
            }
          });
          this.titleArr = channelinfolist;

          if (this.channelidType == "") {
            this.channelidType = `channel${channelinfolist[0].channelid}`;
          }
        }
        /**历史记录 */
        this.dataDome = data.channelinfo;
        this.contentList = data.list;
        let phusList = [];
        if (data.list != undefined && data.list.length > 0) {
          let lengthInfo = data.channelinfo.length;
          for (let i = 0; i < lengthInfo; i++) {
            let ints = i + 1;
            phusList.push("channel" + ints);
          }
        }
        this.Lxpush = phusList;
        this.drawLine(Yechart, Xechart);
      }
    },
    // echarts
    drawLine(Yechart, Xechart) {
      let myChart = this.$echarts.init(document.getElementById("myChart"));

      if (this.titleArr[0] != undefined) {
        let unit =
          this.objUnit.unit == undefined ? this.titleArr[0].unit : this.objUnit.unit;
        let unittype =
          this.objUnit.unittype == undefined
            ? this.titleArr[0].unittype
            : this.objUnit.unittype;

        this.titleObj = {
          unittype,
          unit,
        };

        // 绘制图表
        let option = {
          title: {
            left: "center",
            text: unittype,
            // subtext: '纯属虚构'
          },
          tooltip: {
            trigger: "axis",
          },
          legend: {
            // left: 10,
            // data: ['最高气温',]
          },
          toolbox: {
            show: true,
            feature: {
              dataZoom: {
                yAxisIndex: "none",
              },
              dataView: { readOnly: false },
              magicType: { type: ["line", "bar"] },
              restore: {},
              saveAsImage: {},
            },
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: Xechart,
          },
          yAxis: {
            // name:'11',
            type: "value",
            axisLabel: {
              formatter: "{value}" + unit,
            },
          },

          series: [
            {
              // name: '最高气温',
              smooth: true, //这个是把线变成曲线
              type: "line",
              data: Yechart,
              markPoint: {
                data: [
                  { type: "max", name: "最大值" },
                  { type: "min", name: "最小值" },
                ],
              },
              markLine: {
                data: [{ type: "average", name: "平均值" }],
              },
            },
            // {
            //     name: '最低气温',
            //     type: 'line',
            //     data: [1, -2, 2, 5, 3, 2, 0],
            //     markPoint: {
            //         data: [
            //             {name: '周最低', value: -2, xAxis: 10, yAxis: -1.5}
            //         ]
            //     },
            //     markLine: {
            //         data: [
            //             {type: 'average', name: '平均值'},
            //             [{
            //                 symbol: 'none',
            //                 x: '90%',
            //                 yAxis: 'max'
            //             }, {
            //                 symbol: 'circle',
            //                 label: {
            //                     position: 'start',
            //                     formatter: '最大值'
            //                 },
            //                 type: 'max',
            //                 name: '最高点'
            //             }]
            //         ]
            //     }
            // }
          ],
        };
        myChart.setOption(option);
      }
      // }
    },
    // 树形结构
    async treeinfo(search) {
      let levelid = 4;
      const { code, data, msg } = await treeinfo(levelid, search);
      if (code) {
        this.treeData = data;
      }
    },
  },
};
</script>

<style scoped>
.dataTable {
  width: 100%;
  background: #19c1a3;
  height: 30px;
  line-height: 30px;
  padding: 0 20px;
  color: #ffffff;
  display: flex;
  justify-content: space-between;
}
.lsit {
  display: flex;
  justify-content: space-between;
  height: 100%;
}
.icon {
  /* padding: 0 20px; */
  display: flex;
  align-items: center;
}
.icon img {
  width: 20px;
  height: 20px;
  cursor: pointer;
  /* background: #000; */
}
.set {
  width: 20%;
  height: 100%;
  overflow: auto;
  /* border: 1px solid red; */
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04); */
  /* height: 500px; */
}
.left {
  width: 80%;
  /* border: 1px solid red; */
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04); */
  /* height: 500px; */
  overflow: hidden;
}
.errof {
  background: #ffffff;
}
.lefRight {
  display: flex;
  justify-content: space-between;
  /* height: 500px; */
  /* overflow: hidden; */
}
.right_warp {
  width: 58%;
  /* border: 1px solid black; */
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04); */
  overflow: hidden;
}
.left_warp {
  width: 40%;
  /* height: 450px; */
  /* border: 1px solid black; */
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04); */
  /* overflow: auto; */
}

.times {
  width: 40%;
  display: flex;
  padding: 0 10px 0 0px;
  justify-content: space-between;
}
.timeout {
  width: 100%;
  background: #ffffff;
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04); */
  display: flex;
  align-items: center;
}
.dayTime {
  padding: 0 15px;
  display: flex;
  width: 50%;
  /* justify-content: flex-end; */
  /* float: right; */
}

.tiemOUts {
  text-align: center;
  padding: 10px 0;
}
.zhe_boots {
  text-align: center;
}
.filet {
  display: flex;
  align-items: center;
}
</style>
